// Offset scroll anchor for content pages with a sticky TOC. The reused legacy react-scroll `Anchor`
// scrolls via `window.scrollTo` to the matched element's top, ignoring CSS `scroll-margin`; placing the
// `id` on this `-top-[88px]` absolutely positioned span (rather than the heading itself) lands the
// target clear of the fixed navbar. Pair with `scroll-mt-[88px]` on the container so native `#hash` /
// `scrollIntoView` navigation lands correctly too. Render inside a `position: relative` ancestor.
export const AnchorTarget = ({ id }) => (<span id={id} aria-hidden className="pointer-events-none absolute -top-[88px] left-0"/>);
